// extracted by mini-css-extract-plugin
export default {"footer-links":"Links_footer-links__ySHJV","title":"Links_title__wmmLL","list":"Links_list__B+95i","item":"Links_item__p54XT","link":"Links_link__GseCj"};